import type { ReactNode } from "react";
import classNames from "classnames";
import RcDrawer from "rc-drawer";
import { t } from "@/i18n-js/instance";
import { IconButton } from "../HeaderV3/IconButton";
import { Footer } from "./Footer";
import { Header } from "./Header";
import "./styles.scss";

interface DrawerProps {
  afterVisibleChange?: (open: boolean) => void;
  children?: ReactNode;
  className?: string;
  drawerChildrenClassName?: string;
  fixedHeader?: boolean;
  hideHeader?: boolean;
  maskClosable?: boolean;
  noWrapperPadding?: boolean;
  onChange?: (open?: boolean) => void;
  onClose?: () => void;
  open: boolean;
  title?: ReactNode;
  variant?: "default" | "wide";
  width?: string;
}

/**
 * @deprecated Use `@circle-react-shared/ModalsV2/Drawer` instead.
 */
const Drawer = ({
  open,
  title,
  className,
  hideHeader,
  variant = "default",
  onChange,
  afterVisibleChange,
  onClose,
  children,
  fixedHeader,
  noWrapperPadding,
  maskClosable = false,
  drawerChildrenClassName,
}: DrawerProps) => {
  if (!open) {
    return null;
  }

  return (
    <RcDrawer
      prefixCls="drawer"
      className={classNames(`drawer--${variant}`, className, {
        "drawer--no-padding": noWrapperPadding,
      })}
      open={open}
      level={null}
      placement="right"
      onChange={onChange}
      afterVisibleChange={afterVisibleChange}
      handler={null}
      onClose={onClose}
      maskClosable={maskClosable}
    >
      {!hideHeader && (
        <Header
          title={title}
          fixed={fixedHeader}
          addHeaderPadding={noWrapperPadding}
          Actions={
            <IconButton
              iconSize={24}
              name="24-close"
              onClick={onClose}
              ariaLabel={t("drawer.close_panel")}
              dataTestId="drawer-close-button"
            />
          }
        />
      )}
      {open && (
        <div className={`drawer__children ${drawerChildrenClassName}`}>
          {children}
        </div>
      )}
    </RcDrawer>
  );
};

Drawer.Header = Header;
Drawer.Footer = Footer;

export { Drawer };
